import { Component } from '@angular/core';
import { NEWS_LIST } from '../../shared/data/news-data';

@Component({
  selector: 'app-medianews',
  templateUrl: './medianews.component.html',
  styleUrl: './medianews.component.scss',
})
export class MedianewsComponent {
  newsList = NEWS_LIST;
}
